"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const slice_2 = require("../../../app-reduxs/login/slice");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const components_1 = require("../../../components");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const User_1 = __importDefault(require("../../../networking/apis/User"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const components_2 = require("./components");
const styles_1 = __importDefault(require("./styles"));
const EditBirthdayScreen = (_props) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const [errorMessage, setErrorMessage] = (0, react_1.useState)('');
    const refInputValue = (0, react_1.useRef)('');
    const handleEditBirthday = () => {
        if (!refInputValue.current) {
            return setErrorMessage('生年月日は必須項目です。');
        }
        const date = (0, moment_1.default)(refInputValue.current, 'YYYY/MM/DD', true);
        if (!date.isValid() || date.isAfter(moment_1.default.now())) {
            return setErrorMessage('には有効な日付を指定してください。');
        }
        setErrorMessage('');
        User_1.default.updateBirthday(refInputValue.current)
            .then(_res => {
            dispatch((0, slice_2.updateDateOfBirthAction)(refInputValue.current));
            dispatch(slice_1.default.actions.showToast('生年月日を変更しました'));
            (0, rootNavigation_1.goBack)();
        })
            .catch(err => {
            if (typeof err?.response?.data?.error?.message === 'string') {
                dispatch(slice_1.default.actions.setToastType(false));
                dispatch(slice_1.default.actions.showToast(err.response.data.error.message));
            }
        });
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.Pressable, { style: {
            flex: 1,
            backgroundColor: "#F7F7F7",
            justifyContent: "space-between",
        }, onPress: react_native_1.Keyboard.dismiss, disabled: helpler_1.isWeb },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, title: "生年月日変更", styleContainer: {
                    backgroundColor: Colors_1.default.white,
                }, leftIcon: react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(12),
                        lineHeight: (0, scale_1.moderateScale)(18),
                        color: "#007AFF",
                    } }, "\u30AD\u30E3\u30F3\u30BB\u30EB") }),
            react_1.default.createElement(react_native_1.KeyboardAvoidingView, null,
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.main },
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row" } },
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.Rectangle }),
                        react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                fontSize: (0, scale_1.moderateScale)(16),
                                lineHeight: (0, scale_1.moderateScale)(24),
                                color: "#292A33",
                                fontWeight: "300",
                                paddingLeft: (0, scale_1.scale)(8),
                            } }, "\u751F\u5E74\u6708\u65E5\u5909\u66F4")),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                            paddingTop: (0, scale_1.scale)(12),
                            marginBottom: (0, scale_1.scale)(4),
                        } }, "\u751F\u5E74\u6708\u65E5\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
                    react_1.default.createElement(components_2.InputView, { onChange: (val) => refInputValue.current = val, errorMessage: errorMessage }),
                    react_1.default.createElement(components_1.LinearButton, { containerStyle: { marginTop: (0, scale_1.scale)(32) }, fontWeight: "600", title: "\u4FDD\u5B58", onPress: handleEditBirthday }))))));
};
exports.default = EditBirthdayScreen;
